var map = {
	"./ad.svg": "6eaf",
	"./adopt-vip.svg": "2bb8",
	"./agreed.svg": "bb64",
	"./back-home.svg": "9994",
	"./barrage-vip.svg": "7a7b",
	"./biaoqing.svg": "76dc",
	"./bless_vip.svg": "e123",
	"./consume.svg": "3311",
	"./consume1.svg": "3db3",
	"./danmu.svg": "11e4",
	"./douyin.svg": "c86f",
	"./drink-game.svg": "34813",
	"./effict.svg": "ae19",
	"./expression-vip.svg": "65c1",
	"./gift.svg": "7cb9",
	"./gift_vip.svg": "d60e",
	"./hurry.svg": "081e",
	"./is-top.svg": "a973",
	"./maiba.svg": "d183",
	"./maibatx.svg": "2e14",
	"./mv-vip-icon.svg": "855f",
	"./mv-vip.svg": "d885",
	"./mv_vip.svg": "6721",
	"./my-like.svg": "3301",
	"./new-song.svg": "101d",
	"./no-ad.svg": "f60d",
	"./no-agreed.svg": "52d6",
	"./often.svg": "697b",
	"./photo_vip.svg": "1640",
	"./plus.svg": "3413",
	"./plus1.svg": "5d72",
	"./rights-dadie.svg": "2de8",
	"./rights-dj.svg": "0333",
	"./rights-geshen.svg": "c582",
	"./rights-wuqu.svg": "9e93",
	"./room.svg": "106e",
	"./save-order.svg": "42ad",
	"./vip-adopt.svg": "8361",
	"./vip-bless.svg": "262b",
	"./vip-gift.svg": "560c",
	"./vip-photo.svg": "a870",
	"./vip_barrage.svg": "b798",
	"./vip_bless.svg": "8073",
	"./vip_drink.svg": "c27c",
	"./vip_expression.svg": "f8615",
	"./vip_gift.svg": "08d8",
	"./vip_mv.svg": "a656",
	"./vip_photo.svg": "096c",
	"./vip_video.svg": "e39e",
	"./your-gift.svg": "86b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";